import { render, staticRenderFns } from "./AddTargetDayWiseData.vue?vue&type=template&id=655e64b0"
import script from "./AddTargetDayWiseData.vue?vue&type=script&lang=js"
export * from "./AddTargetDayWiseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports